import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Box, Collapse, List, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { FunctionComponent, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppTranslate } from '../../hooks';
import { getItemChildren, getItemNavigation, SideBarNestedMenuItem, SideBarTopMenuItem } from './SidebarMenuItem.model';

interface Props {
  item: SideBarTopMenuItem;
  wideMenu: boolean;
}

export const SidebarMenuItem: FunctionComponent<Props> = ({ item, wideMenu }) => {
  const [submenuOpen, setSubmenuOpen] = useState<boolean>(false);
  const translate = useAppTranslate();
  const navigate = useNavigate();
  const location = useLocation();
  const primaryColor = useTheme().palette.primary.main;
  const itemChildren: SideBarNestedMenuItem[] = getItemChildren(item);
  const navigation: string = getItemNavigation(item);
  const isMenuBlockActive = location.pathname === navigation || itemChildren.some(item => item.navigation === location.pathname);
  const handleMenuItemClick = (): void => {
    if (itemChildren.length) {
      setSubmenuOpen(currentValue => !currentValue);
    } else if (navigation) {
      navigate(navigation);
    } else {
      console.error('No navigation or children items defined for menu');
    }
  };

  return <>
    <Box sx={{ px: { sm: 1 }, color: isMenuBlockActive ? primaryColor : 'inherit' }}>
      <ListItemButton sx={{ borderRadius: '0.5rem', justifyContent: wideMenu ? 'flex-start' : 'center' }}
                      onClick={handleMenuItemClick}
      >
        <ListItemIcon sx={{ justifyContent: wideMenu ? 'start' : 'center', minWidth: '2.5rem' }}>
          <item.icon />
        </ListItemIcon>
        {wideMenu && <ListItemText primary={translate(item.labelTranslationKey, { ns: 'menu' })}></ListItemText>}
        {itemChildren.length ? (submenuOpen ? <ExpandLess /> : <ExpandMore />) : null}
      </ListItemButton>
    </Box>
    {Boolean(itemChildren.length) && <Collapse in={submenuOpen} timeout="auto" unmountOnExit>
      <List component="div" disablePadding>
        {itemChildren.map(nestedItem => {
          const isRouteActive = location.pathname === nestedItem.navigation;

          return <Box key={nestedItem.labelTranslationKey}
                      sx={{
                        px: { sm: 1 },
                        color: isRouteActive ? primaryColor : 'inherit'
                      }}>
            <ListItemButton sx={{ pl: '3.5rem', borderRadius: '0.5rem', backgroundColor: isRouteActive ? '#EFF6FF' : 'transparent' }}
                            onClick={() => navigate(nestedItem.navigation)}
            >
              <ListItemText primary={translate(nestedItem.labelTranslationKey, { ns: 'menu' })} />
            </ListItemButton>
          </Box>
        })}
      </List>
    </Collapse>
    }
  </>;
};
